// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".storyblok-column{width:204px;min-height:115px;display:flex;flex-direction:column}@media(max-width:960px){.storyblok-column{min-height:auto!important;width:100%!important;text-align:center}}.storyblok-column a{color:#009fe3!important;text-decoration:none;cursor:pointer}.storyblok-column ol>li,.storyblok-column ul{margin-left:2em}", ""]);
// Exports
module.exports = exports;
